import Swiper from 'swiper/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const createSwiper = (selector, config) => new Swiper(selector, config);

    const commonConfig = {
        direction: "horizontal",
        slidesPerView: 1.2,
        spaceBetween: 20,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    };

    createSwiper(".stakeholder-banner-slider", {
        ...commonConfig,
        spaceBetween: 20,
        breakpoints: {
            1024: {
                slidesPerView: 4,
                spaceBetween: 36,
            },
        },
    });

    createSwiper(".stakeholder-programs-slider", {
        ...commonConfig,
        spaceBetween: 12,
        breakpoints: {
            1024: {
                slidesPerView: 3,
                spaceBetween: 40,
            },
        },
    });
});
